export default {
  "betOrder.thead.userNo": "用户编号",
  "betOrder.thead.email": "邮箱",
  "betOrder.thead.gameName": "游戏名称",
  "betOrder.thead.gameType": "游戏类型",
  "betOrder.thead.betType": "投注类型",
  "betOrder.thead.betAmount": "投注金额",
  "betOrder.thead.validBet": "有效投注",
  "betOrder.thead.resultAmount": "结果金额",
  "betOrder.thead.lossWinAmount": "输赢金额",
  "betOrder.thead.providerName": "提供商名称",
  "betOrder.thead.betTime": "投注时间",
  "betOrder.thead.resultTime": "结算时间",
  "betOrder.thead.betFinish": "结算状态",
  "betOrder.thead.isCancel": "是否取消",
  "betOrder.thead.isCancel.yes": "是",
  "betOrder.thead.isCancel.no": "否",
  "betOrder.thead.betOrderno": "投注订单号",
  "betOrder.thead.merBetOrderno": "商户投注订单号",
  "betOrder.title": "投注订单",
};
